import React from 'react';
import {
  ProPlaceholderOption,
  ProSelectInputWrapper,
  StyledProSelectInput
} from 'elements/forms/inputs/ProSelectInput.styles';
import { RequiredAsteriskWrapper, StyledLabel } from './ProTextInput.styles';

interface ProSelectInputProps {
  label: string;
  placeholder: string;
  options: string[];
  inputName: string;
  onSelect: (value: string) => void;
  required?: boolean;
}

const ProSelectInput = (props: ProSelectInputProps): JSX.Element => {
  return (
    <ProSelectInputWrapper>
      <StyledLabel>
        {props.label}
        {props.required && <RequiredAsteriskWrapper>*</RequiredAsteriskWrapper>}
      </StyledLabel>

      <StyledProSelectInput defaultValue="" required={props.required} name={props.inputName} onChange={(e) => props.onSelect(e.target.value)}>
        <ProPlaceholderOption value="">
          {props.placeholder}
        </ProPlaceholderOption>

        {props.options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </StyledProSelectInput>
    </ProSelectInputWrapper>
  );
};

export default ProSelectInput;
